import React, { useContext, useEffect, useState } from 'react';
import { Button, Typography, Checkbox, FormControlLabel, Accordion, AccordionDetails, AccordionSummary, Divider, FormGroup, CircularProgress, Box, Card, CardContent, Chip, Paper } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import endpoints from '../constants/endpoints';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import Detail from './Detail';
import useFetch from '../hooks/useFetch';
import useApiRequest from '../services/apiRequest';
import { Tooltip, IconButton } from '@mui/material';
import { Info } from '@mui/icons-material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import FacetsDialog from './FacetsDialog';


function Facets() {
	const { queryStringConverter} = useApiRequest();
	const { description, filters, searchType: search_type, setFilters, cleanFilters } = useContext(GlobalStateContext);
	const { selectedFacets, setSelectedFacets } = useContext(GlobalStateContext);
	const { data, error, loading } = useFetch(`${endpoints.ITEMS_FACETS}${queryStringConverter({ search_type })}`, JSON.stringify({ description, ...filters }), "POST")
	const [openFacetDialog, setOpenFacetDialog] = useState(false);
	const [selectedFacet, setSelectedFacet] = useState({});
	const [selectedFacetLabel, setSelectedFacetLabel] = useState('');
	const [selectedFacetName, setSelectedFacetName] = useState('');

	let labels: string[] = [];

	const getField = (label: string) => filters[label] || [];

	const filterChecked = (filter: string, facet_label: string) => {
		let field = getField(filter)
		return field.includes(facet_label)
	}

	const handleChangeCheck = (ev: React.ChangeEvent<HTMLInputElement>) => {
		const label = ev.target.id.split("::")[0]
		let field = getField(label)

		if (ev.target.checked) {
			field.push(ev.target.name)
			setSelectedFacets([...selectedFacets, { id: ev.target.name, facet: label, label: ev.target.name, qtd: 0 }])
		}
		if (!ev.target.checked) {
			field = field.splice(field.indexOf(ev.target.name), 1)
			setSelectedFacets(selectedFacets.filter((facet) => facet.label !== ev.target.name))
		}

		setFilters({ ...filters });

	}

	const getLabels = () => {
		data.facets.map((element: any, index: any) => {
			labels.push(element.field_label);
		})
	}

	const expandAccordion = (element: string) => {
		return (filters[element]?.length || 0) > 0;
	};

	const clearFacets = (element: any) => {
		setSelectedFacets(selectedFacets.filter((facet) => facet.facet !== element.filter))
		setFilters({ ...filters, ...{ [element.filter]: [] } });
	}



	return (
		<>
			<FacetsDialog open={openFacetDialog} onClose={() => setOpenFacetDialog(false)} facet={selectedFacetLabel} facetName={selectedFacetName} />
			<div >
				{loading || !data
					? <div className='h-result flex flex-col justify-center items-center'><CircularProgress /></div>
					: [
						<div >
							<div className="flex flex-col min-h-screen bg-slate-100">
								<Paper sx={{ width: "95%", mx: 'auto', my: 1, padding: 0.5 }} elevation={0}>

									{data.facets.map((element: any, index: any) => {
										getLabels();
										return (

											<Box key={index}>

												<div className='justify-start p-1'>

													<Accordion defaultExpanded={expandAccordion(element.filter)} sx={{ width: '100%' }}>
														<AccordionSummary
															expandIcon={<ExpandMoreIcon />}
															aria-controls="panel1a-content"
															id="panel1a-header"
															sx={{ bgcolor: '#00617b', color: 'white', borderRadius: 1 }}
														>
															<Tooltip title={<React.Fragment>
																<p>
																	{element.info}
																</p>
															</React.Fragment>}>
																<IconButton size='small'>
																	<Info color="secondary" />
																</IconButton>
															</Tooltip>
															<Typography sx={{ mt: 0.5 }}>{labels[index]}</Typography>
														</AccordionSummary>
														<AccordionDetails>
															{element.facets.length === 0 ? <></> :
																<>
																	<div className="my-2 flex flex-col">
																		<FormGroup>
																			<Button sx={{ width: '40%', ml: 0.5 }} variant='text' color="warning" size='small' startIcon={<HighlightOffIcon />} onClick={() => clearFacets(element)}>
																				Resetar
																			</Button>

																			{element.filter == 'base_facet' || element.filter == 'prd_serv_facet'

																				?

																				element.field == "fonte"
																					?
																					<>
																						<Typography variant='subtitle1' sx={{ mt: 1, textAlign: 'center' }} color="initial">Compras Públicas</Typography>
																						<Divider sx={{ mb: 1 }} />
																						{element.facets.map((facet: any, index: any) => (
																							facet.category === "COMPRAS PÚBLICAS" ?
																								<React.Fragment key={index}>
																									<Box sx={{ display: 'flex', mt: -0.5, justifyContent: 'space-between' }}>
																										<Box sx={{ display: 'flex' }}>
																											<Checkbox size='small' id={element.filter + "::" + facet.label} name={facet.label} aria-label={facet.label} onChange={handleChangeCheck} checked={filterChecked(element.filter, facet.label)} />
																											<Typography variant='body1' sx={{ mt: 1 }} color="initial">{facet.label.length <= 50 ? facet.label : (facet.label.substr(0, 50) + "...")}</Typography>
																										</Box>
																										<Box sx={{ display: 'flex', mt: 1 }}>
																											<Chip label={facet.count} size='small' color='primary' sx={{ ml: 0.5 }} variant='outlined' />
																										</Box>
																									</Box>

																								</React.Fragment>
																								: <></>
																						))}


																						{element.facets.some((facet: any) => facet.category === "PREÇOS DE REFERÊNCIA") && (
																							<>
																								<Typography variant='subtitle1' sx={{ mt: 1, textAlign: 'center' }} color="initial">Preços de Referência</Typography>
																								<Divider />
																							</>
																						)}

																						{element.facets.map((facet: any, index: any) => (
																							facet.category === "PREÇOS DE REFERÊNCIA" &&
																							<React.Fragment key={index}>
																								<Box sx={{ display: 'flex', mt: -0.5, justifyContent: 'space-between' }}>
																									<Box sx={{ display: 'flex' }}>
																										<Checkbox size='small' id={element.filter + "::" + facet.label} name={facet.label} aria-label={facet.label} onChange={handleChangeCheck} checked={filterChecked(element.filter, facet.label)} />
																										<Typography variant='body1' sx={{ mt: 1 }} color="initial">{facet.label.length <= 50 ? facet.label : (facet.label.substr(0, 50) + "...")}</Typography>
																									</Box>
																									<Box sx={{ display: 'flex', mt: 1 }}>
																										<Chip label={facet.count} size='small' color='primary' sx={{ ml: 0.5 }} variant='outlined' />
																									</Box>
																								</Box>

																							</React.Fragment>
																						))}

																					</>
																					:

																					element.filter == 'prd_serv_facet' ?
																						element.facets.map((facet: any, index: any) => {

																							return (
																								<React.Fragment key={`${element.filter}_${facet.label}`}>
																									<Box sx={{ display: 'flex', mt: -0.5, justifyContent: 'space-between' }}>
																										<Box sx={{ display: 'flex' }}>
																											<Checkbox size='small' id={`${element.filter}::${facet.label}`} name={facet.label} aria-label={facet.label} onChange={handleChangeCheck} checked={filterChecked(element.filter, facet.label)} />
																											<Typography variant='body1' sx={{ mt: 1 }} color="initial">{facet.label.length <= 50 ? facet.label : (facet.label.substr(0, 50) + "...")}</Typography>
																										</Box>
																										<Box sx={{ display: 'flex', mt: 1 }}>
																											<Chip label={facet.count} size='small' color='primary' sx={{ ml: 0.5 }} variant='outlined' />
																										</Box>
																									</Box>
																								</React.Fragment>
																							);

																						})

																						: <></>
																				:

																				<>
																					{element.facets.map((facet: any, index: any) => {
																						if (filterChecked(element.filter, facet.label)) {
																							return (
																								<React.Fragment key={`${element.filter}_${facet.label}`}>
																									<Box sx={{ display: 'flex', mt: -0.5, justifyContent: 'space-between' }}>
																										<Box sx={{ display: 'flex' }}>
																											<Checkbox size='small' id={`${element.filter}::${facet.label}`} name={facet.label} aria-label={facet.label} onChange={handleChangeCheck} checked={filterChecked(element.filter, facet.label)} />
																											<Typography variant='body1' sx={{ mt: 1 }} color="initial">{facet.label.length <= 50 ? facet.label : (facet.label.substr(0, 50) + "...")}</Typography>
																										</Box>
																										<Box sx={{ display: 'flex', mt: 1 }}>
																											<Chip label={facet.count} size='small' color='primary' sx={{ ml: 0.5 }} variant='outlined' />
																										</Box>
																									</Box>
																								</React.Fragment>
																							);
																						}
																					})}

																					{element.facets.map((facet: any, index: any) => {
																						if (!filterChecked(element.filter, facet.label)) {
																							return (
																								<React.Fragment key={`${element.filter}_${facet.label}`}>
																									<Box sx={{ display: 'flex', mt: -0.5, justifyContent: 'space-between' }}>
																										<Box sx={{ display: 'flex' }}>
																											<Checkbox size='small' id={`${element.filter}::${facet.label}`} name={facet.label} aria-label={facet.label} onChange={handleChangeCheck} checked={filterChecked(element.filter, facet.label)} />
																											<Typography variant='body1' sx={{ mt: 1 }} color="initial">{facet.label.length <= 50 ? facet.label : (facet.label.substr(0, 50) + "...")}</Typography>
																										</Box>
																										<Box sx={{ display: 'flex', mt: 1 }}>
																											<Chip label={facet.count} size='small' color='primary' sx={{ ml: 0.5 }} variant='outlined' />
																										</Box>
																									</Box>
																								</React.Fragment>
																							);
																						}
																					})}

																				</>
																			}
																		</FormGroup>

																	</div>

																	{element.filter != 'base_facet' && element.filter != 'prd_serv_facet' ?
																		<Button variant="text" color="primary" size='small' sx={{ ml: '35%' }} onClick={() => {
																			setSelectedFacetName(element.field_label);
																			setSelectedFacetLabel(element.filter);
																			setOpenFacetDialog(true);
																		}}>
																			Ver Todas
																		</Button>
																		: <></>}
																</>
															}
														</AccordionDetails>
													</Accordion>
												</div>

											</Box>
										)
									}
									)}

								</Paper>



							</div>

						</div>
					]
				}</div>
		</>

	);
}

export default Facets;


